import request from '@/router/axios';

export const add = () => {
    return request({
        url: '',
        method: 'post'
    })
}

export const remove = () => {
    return request({
        url: '',
        method: 'post'
    })
}

export const update = () => {
    return request({
        url: '',
        method: 'post'
    })
}

export const getDetail = () => {
    return request({
        url: '',
        method: 'post'
    })
}


//compensation-page
export const compensationPage = (current, size, params) => {
    return request({
        url: '/api/v2/blade-loanPost/compensation/compensation-page',
        method: 'post',
        data: {
            ...params,
            current,
            size,
        }
    })
}

//calculateCompensationTotal
export const calculateCompensationTotal = (current, size, params) => {
    return request({
        url: '/api/v2/blade-loanPost/compensation/calculateCompensationTotal',
        method: 'post',
        data: {
            ...params,
            current,
            size,
        }
    })
}


//returnCompensation
export const returnCompensation = (id) => {
    return request({
        // url: '/api/blade-loanPost/compensation/returnCompensation?id=' + id,
        url: '/api/v2/blade-loanPost/compensation/returnCompensation?id=' + id,
        method: 'get',
    })
}


//compensation-export
export const exportCompensation = (data) => {
    return request({
        // url: `/api/blade-loanPost/compensation/compensation-export`,
        url: `/api/v2/blade-loanPost/compensation/compensation-export`,
        method: "post",
        responseType: 'blob',
        data: data,
    });
}